export function nextOffset(limit: number, page: number, offset: number) {
	return limit * page - limit + offset;
}
